import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SlideUp } from "@/components/ui/motion-wrappers";

export interface FAQItem {
    question: string;
    answer: string;
}

interface ServiceFAQProps {
    items: FAQItem[];
    title?: string;
    description?: string;
    id?: string;
}

export const ServiceFAQ = ({
    items,
    title = "Common Questions",
    description = "Everything you need to know about this system.",
    id = "faq"
}: ServiceFAQProps) => {
    // Generate FAQ Schema
    const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": items.map(item => ({
            "@type": "Question",
            "name": item.question,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": item.answer
            }
        }))
    };

    return (
        <section className="py-24 bg-background" id={id}>
            <script type="application/ld+json">
                {JSON.stringify(faqSchema)}
            </script>

            <div className="container mx-auto px-6 max-w-3xl">
                <div className="text-center mb-12">
                    <SlideUp>
                        <h2 className="text-3xl font-bold mb-4">{title}</h2>
                        <p className="text-muted-foreground">{description}</p>
                    </SlideUp>
                </div>

                <SlideUp delay={0.1}>
                    <Accordion type="single" collapsible className="w-full">
                        {items.map((item, index) => (
                            <AccordionItem key={index} value={`item-${index}`}>
                                <AccordionTrigger className="text-left text-lg font-medium">
                                    {item.question}
                                </AccordionTrigger>
                                <AccordionContent className="text-muted-foreground text-base leading-relaxed">
                                    {item.answer}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </SlideUp>
            </div>
        </section>
    );
};
